import React from "react";
import imageOne from '../../resource/community/funeral/1.png'
import imageThree from '../../resource/community/funeral/2.png'

import imagefive from '../../resource/community/funeral/photo.jpeg'

import TitleChnage from "../../Hook/TitleChnage";

import calendor from '../../resource/events/calendar/calendor.png'

const FuneralRituals = () => {
    return (
        <div className="paritta-page inside-pages">
        <div className="right-box">
            <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
        </div>

        <h1 className='font-main  p-4'>Funeral Rituals</h1>

        <p className="h4 p-4 mt-5 ">In Buddhism, death is regarded as a significant event, holding profound meaning for both the deceased and the living. For those who remain, it serves as a powerful reminder of the Buddha’s teachings on impermanence. For the deceased, death provides an opportunity for others to assist in their journey toward a more favorable rebirth. These dual aspects of death are reflected in the funeral rites and ceremonies observed in the Buddhist tradition.</p>
        <p className="h4 p-4 mt-5 ">A funeral is an event that brings heaviness to the hearts of loved ones. Traditional Buddhist funeral ceremonies are led by the Sangha to support and comfort the mourners, explaining the reality of life and the truth of existence. They perform special rituals and chants to share merits with the departed relatives.</p>
       <p className="h4 p-4 mt-5">The community can invite the Sangha from Bhaddeka Vihari Monastery to lead the funeral rituals for their loved ones.</p>
       


        <h3 className="font-second p-4 mt-6">Funeral Rituals Guidelines</h3>
        <p className="h4 p-4 mt-5">At Bhaddeka Vihari Monastery, the Sangha graciously assist the lay community during funerals by participating in various religious rites and rituals. These rituals aim to alleviate the grief of the relatives while transferring merits to the departed, ensuring an auspicious rebirth. Some of the key rituals and practices include:</p>

        <p className="h4 p-4 mt-4 text-bold dark-gold">1. Delivering Dhamma Discourses</p>
        <p className="h4 p-4 mt-4">The Sangha offer sermons that emphasize the impermanent nature of life, helping to alleviate the grief and sense of loss experienced by the bereaved family and friends. These teachings provide solace and comfort, guiding them to a deeper understanding of life’s transient nature as taught by the Buddha.</p>
    
        <p className="h4 p-4 mt-4 text-bold dark-gold">2. Water-Pouring Ceremony</p>
        <p className="h4 p-4 mt-4">In this ritual, close family members seated beside the coffin pour water from a small pot into a bowl while the Sangha chants verses of merit transference. This act symbolizes the offering of merit to the deceased.</p>
    
        <p className="h4 p-4 mt-4 text-bold dark-gold">3. Mathaka Bana</p>
        <p className="h4 p-4 mt-4">After seven days and three months following the departure of a loved one, a Dhamma discourse, known as Mathaka Bana, is delivered by a member of the Sangha to benefit the family and remind them of the Buddha's teachings.</p>
    

        <p className="h4 p-4 mt-4 text-bold dark-gold">4. Mathaka Dana</p>
        <p className="h4 p-4 mt-4">After seven days and three months, an almsgiving ceremony known as Mathaka Dana is conducted. Offerings are made to the Sangha, providing another opportunity to transfer merit to the departed.</p>
    
        <div className="funeralResult p-5">
        <img src={imagefive} alt="" style={{ width: "100%" }} />
            <div className="inforamtions">
            <p className="h4 p-4 mt-4 text-bold dark-gold">Sharing Merits with Departed Relatives</p>
        <p className="h4 p-4 mt-4">The successful execution of these rites and rituals depends not only on the spiritual guidance of the Sangha but also on the collective efforts of the lay community. Family, friends, and neighbors come together to perform various meritorious acts, generating collective merit for the benefit of the deceased.</p>
        <p className="h4 p-4 mt-4">In addition to the funeral-specific ceremonies, family and friends can continue to generate merit on behalf of their departed loved ones by engaging in wholesome activities. Since it is not possible to share tangible items with the departed, transferring merit remains the only way to support them. Such activities may include:</p>

    
            </div>
        </div>

        <p className="h4 p-4 mt-6">• Undertaking temporary ordination as a monk</p>
        <p className="h4 p-4 mt-4">• Practicing meditation</p>
        <p className="h4 p-4 mt-4">• Observing higher precepts</p>
        <p className="h4 p-4 mt-4">• Serving as an attendant to the Sangha for a period of time</p>
        <p className="h4 p-4 mt-4">• Supporting the Sangha through almsgiving</p>
        <p className="h4 p-4 mt-4">• Contributing to monastery development and maintenance</p>
        <p className="h4 p-4 mt-4">• Organizing Dhamma events and retreats</p>

        <p className="h4 p-4 mt-6">These activities are meaningful ways to contribute to the collective accumulation of merit. At Bhaddeka Vihari Monastery, the Sangha welcomes and encourages such efforts, recognizing their vital role in fostering spiritual growth and ensuring a respectful and meaningful farewell for the departed.</p>

        <h3 className="font-second p-4 mt-6">Funeral Service Chanting</h3>
        <p className="h4 p-4 mt-4">During the funeral ceremony, the following verses are chanted. These verses are from the Mahaparinibbana Sutta, delivered by the god Sakka after the death of the Buddha:</p>

<div className="gatha mt-5">
    <div className="left-side">
    <div >
    <p className="h4 p-4 mt-4 ">Impermanent, alas, are formations,</p>
    <p className="h4 p-4 mt-4 ">Subject to rise and fall.</p>
    <p className="h4 p-4 mt-4">Having arisen, they cease;</p>
    <p className="h4 p-4 mt-4">Their subsiding is bliss.</p>
    </div>

    </div>
    <div className="right-side">
    <p className="h4 p-4 mt-4">Aniccā vata saṅkhārā,</p>
    <p className="h4 p-4 mt-4">uppādavayadhammino.</p>
    <p className="h4 p-4 mt-4">Uppajjitvā nirujjhanti,</p>
    <p className="h4 p-4 mt-4">tesaṃ vūpasamo sukho.</p>
    </div>
</div>


<p className="h4 p-4 mt-6">During the water-pouring ritual, relatives pour water from a vessel to an overflowing cup to symbolize the giving of merit to the deceased. The following verses are recited:</p>

<div className="gatha mt-5">
    <div className="left-side">
    <div >
    <p className="h4 p-4 mt-4 ">As water raining on a hill</p>
    <p className="h4 p-4 mt-4 ">Flows down to the valley,</p>
    <p className="h4 p-4 mt-4">Even so does what is given here</p>
    <p className="h4 p-4 mt-4">Benefit the dead.</p>
    </div>

    </div>
    <div className="right-side">
    <p className="h4 p-4 mt-4">Unname udakaṃ vaṭṭhaṃ yathā,</p>
    <p className="h4 p-4 mt-4">ninnaṃ pavattati,</p>
    <p className="h4 p-4 mt-4">Evameva ito dinnaṃ,</p>
    <p className="h4 p-4 mt-4">petānaṃ upakappati.</p>
    </div>
</div>


<div className="gatha mt-5">
    <div className="left-side">
    <div >
    <p className="h4 p-4 mt-4 ">As rivers full of water</p>
    <p className="h4 p-4 mt-4 ">Fill the ocean full,</p>
    <p className="h4 p-4 mt-4">Even so does what is given here</p>
    <p className="h4 p-4 mt-4">Benefit the dead.</p>
    </div>

    </div>
    <div className="right-side">
    <p className="h4 p-4 mt-4">Yathā vārivahā pūrā,</p>
    <p className="h4 p-4 mt-4">paripūrenti sāgaraṃ,</p>
    <p className="h4 p-4 mt-4">Evameva ito dinnaṃ,</p>
    <p className="h4 p-4 mt-4">petānaṃ upakappati.</p>
    </div>
</div>

        <div className="mt-6 calander-box align-item-center p-4 text-center">
                <div className="c-details text-left">
                    <h2 className='intro-text '>Contact Details</h2>
                    <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                    <p className="font-p">Mr Gamini : 0422 069 359</p>
                    <p className="font-p">WhatsApp : 0422 069 359</p>
                    <p className="font-p">E-mail : info@bvp.org.au</p>
                </div>
               
            </div>




            <div className="bottom-box mt-5">
            <img src={imageThree} alt="bottom-image" width={600} />
        </div>
        </div>
    )
}

export default FuneralRituals;